
import axios from 'axios';
import { getAuthToken, getPortalType } from '@/utils/auth';
import { API_BASE_URL } from './config';

const getAuthHeaders = () => {
  const portal = getPortalType(window.location.pathname || '');
  const token = getAuthToken(portal);
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const userActivitiesAPI = {
  /**
   * Reset all activity completions for a chapter.
   * Used by "START MY JOURNEY" button.
   * 
   * @param {number} chapterId - ID of the chapter to reset
   * @returns {Promise<Object>} Response with deleted_count and message
   */
  resetChapterActivities: async (chapterId) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/users/chapters/${chapterId}/reset-activities/`,
        {},
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error resetting chapter activities:', error);
      throw error;
    }
  },

  /**
   * Get all activity completions for a chapter.
   * 
   * @param {number} chapterId - ID of the chapter
   * @returns {Promise<Array>} Array of completion objects
   */
  getChapterCompletions: async (chapterId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/users/activity-completions/?chapter_id=${chapterId}`,
        { headers: getAuthHeaders() }
      );
      return response.data.results || response.data;
    } catch (error) {
      console.error('Error getting chapter completions:', error);
      throw error;
    }
  },

  /**
   * Complete an activity and record the completion with scoring.
   * 
   * @param {number} annotationId - ID of the annotation/activity
   * @param {number} chapterId - ID of the chapter
   * @param {Object} scoringData - Scoring data (xp_earned, gems_earned, performance_score, etc.)
   * @returns {Promise<Object>} Completion data
   */
  completeActivity: async (annotationId, chapterId, scoringData = {}) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/users/activity-completions/`,
        {
          annotation_id: annotationId,
          chapter_id: chapterId,
          ...scoringData
        },
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error completing activity:', error);
      throw error;
    }
  }
};

